import React from "react"
import { TimelineProps } from "./interfaces"
import withVisibility from "components/Shared/Hocs/withVisibility"
import TimelineTemplateManagerConfig from "./components/Templates/TimelineTemplatesManagerConfig"
import { getFormattedDates, metricMapper } from "./utils"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"

const Timeline = (props: TimelineProps) => {
	const { template } = props
	const Template = TimelineTemplateManagerConfig[template]

	if (!Template) {
		return null
	}

	const { moduleState } = useFiltersContext()
	const {
		transactional: {
			benchmark: { metric },
		},
	} = moduleState
	const timelineMetric = metricMapper(metric, moduleState)
	const { filters, period, interval: intervalDates } = useFiltersContext()
	const [current, previous] = intervalDates
	const dates = getFormattedDates(current, previous)

	return (
		<Template
			{...props}
			metric={metric}
			timelineMetric={timelineMetric}
			filters={filters}
			dates={dates}
			period={period}
		/>
	)
}

export default withVisibility(Timeline)
